import { z } from 'zod'

export const manualExclusionSchema = z.object({
	manufacturer: z.object({ name: z.string(), plid: z.string() }, { message: 'Required' }),
	customer: z.object({ name: z.string(), plid: z.string() }, { message: 'Required' }),
	program: z.string({ message: 'Required' }),
})

export type ManualExclusionSchema = z.infer<typeof manualExclusionSchema>

// This is the *form* schema the RHF form resolves against:
export const manualExclusionsSchema = z.object({
	manualExclusions: z.array(manualExclusionSchema),
})

export type ManualExclusionsFormValues = z.infer<typeof manualExclusionsSchema>
